module.exports = __webpack_public_path__ + "img/break_it.4c58dc73.svg";